import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, take } from 'rxjs/operators'
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../environments/environment'
import { Feedback } from '../../classes/feedback.model';

// const httpOptions = {
//   headers: new HttpHeaders({
//     'Content-Type': 'application/json'
//   })
// }

@Injectable({
  providedIn: 'root'
})

// @Injectable()
export class FeedbackService {
  selectedFeedback: Feedback;
  feedbacks: Feedback[];
  readonly baseURL = "http://localhost:3000/feedbacks";


  constructor(private http: HttpClient) { }

  postFeedback(feedModel: Feedback) {
    const formData: FormData = new FormData();
    console.log({ feedModel });
    formData.append('wasHelpful', feedModel.wasHelpful.toString());
    formData.append('uiIsGood', feedModel.uiIsGood.toString());
    formData.append('iWillUseIt', feedModel.iWillUseIt.toString());
    formData.append('majorProblems', feedModel.majorProblems.toString());
    formData.append('suggestions', feedModel.suggestions.toString());
    if (feedModel.files) {
      for (let i = 0; i < feedModel.files.length; i++) {
        console.log("appending file" + i);
        formData.append('file' + i, feedModel.files[i], feedModel.files[i].name);
      }
    }
    console.log(formData);
    return this.http.post(this.baseURL, formData).toPromise();
  }
}
